<template>
  <el-button-group>
    <el-button-group
      v-for="(group, groupIndex) in actions"
      :key="groupIndex"
      :class="{ 'pl-2': groupIndex > 0 }"
    >
      <template v-for="(action, index) in group">
        <el-button
          v-if="buttonVisible(action)"
          :key="index"
          v-loading="action.loading || false"
          size="mini"
          :type="action.type"
          @click.native="action.event"
        >
          <FontAwesomeIcon
            :icon="action.icon"
            fixed-width
            class="pr-2"
          />{{ action.name }}
        </el-button>
        <el-dropdown
          v-else-if="dropdownVisible(action)"
          :key="index"
          trigger="click"
        >
          <el-button
            size="mini"
            border="0"
          >
            <FontAwesomeIcon
              :icon="action.icon"
              fixed-width
              class="pr-2"
            />{{ action.name }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(subAction, subIndex) in action.dropdown.actions"
              :key="subIndex"
              @click.native="subAction.event"
            >
              <FontAwesomeIcon
                :icon="subAction.icon"
                fixed-width
                class="pr-2"
              />{{ subAction.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-button-group>
  </el-button-group>
</template>

<script>
export default {
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  methods: {
    buttonVisible (action) {
      return (action.visible || !action.hidden) && !action.dropdown
    },
    dropdownVisible (action) {
      return action.dropdown && (action.visible || !action.hidden)
    }
  }
}
</script>
